export const LOAD_LOGIN_LIST = 'MANAGE_LOGIN/LOAD_LOGIN_LIST';
export const LOAD_LOGIN_LIST_SUCCESS = 'MANAGE_LOGIN/LOAD_LOGIN_LIST_SUCCESS';
export const LOAD_LOGIN_LIST_ERROR = 'MANAGE_LOGIN/LOAD_LOGIN_LIST_ERROR';
export const RESET_LOGIN_LIST = 'MANAGE_LOGIN/RESET_LOGIN_LIST';

export const LOAD_LOGIN_DETAILS = 'MANAGE_LOGIN/LOAD_LOGIN_DETAILS';
export const LOAD_LOGIN_DETAILS_SUCCESS =
  'MANAGE_LOGIN/LOAD_LOGIN_DETAILS_SUCCESS';
export const LOAD_LOGIN_DETAILS_ERROR = 'MANAGE_LOGIN/LOAD_LOGIN_DETAILS_ERROR';
export const RESET_LOGIN_DETAILS = 'MANAGE_LOGIN/RESET_LOGIN_DETAILS';

export const ADD_LOGIN = 'MANAGE_LOGIN/ADD_LOGIN';
export const ADD_LOGIN_SUCCESS = 'MANAGE_LOGIN/ADD_LOGIN_SUCCESS';
export const ADD_LOGIN_ERROR = 'MANAGE_LOGIN/ADD_LOGIN_ERROR';

export const UPDATE_LOGIN = 'MANAGE_LOGIN/UPDATE_LOGIN';
export const UPDATE_LOGIN_SUCCESS = 'MANAGE_LOGIN/UPDATE_LOGIN_SUCCESS';
export const UPDATE_LOGIN_ERROR = 'MANAGE_LOGIN/UPDATE_LOGIN_ERROR';

export const CHANGE_STATUS_LOGIN = 'MANAGE_LOGIN/CHANGE_STATUS_LOGIN';
export const CHANGE_STATUS_LOGIN_SUCCESS =
  'MANAGE_LOGIN/CHANGE_STATUS_LOGIN_SUCCESS';
export const CHANGE_STATUS_LOGIN_ERROR =
  'MANAGE_LOGIN/CHANGE_STATUS_LOGIN_ERROR';

export const CHANGE_PASSWORD_LOGIN = 'MANAGE_LOGIN/CHANGE_PASSWORD_LOGIN';
export const CHANGE_PASSWORD_LOGIN_SUCCESS =
  'MANAGE_LOGIN/CHANGE_PASSWORD_LOGIN_SUCCESS';
export const CHANGE_PASSWORD_LOGIN_ERROR =
  'MANAGE_LOGIN/CHANGE_PASSWORD_LOGIN_ERROR';
